<template>
  <v-card class="show-info-teacher">
    <v-divider></v-divider>
    <div class="closeDetailClass" @click="closeModalDetailClass">
      <v-icon large>mdi-close</v-icon>
    </div>
    <div class="content-teacher mt-5">
      <div>
        <validation-observer ref="validator">
          <v-form class="nav-infoTeacher" ref="formValidate">
            <v-list-item>
              <div class="image-subject">
                <b>{{ imageSubject }}</b>
              </div>
              <v-list-item-content class="list-gender-name">
                <div class="update-name">
                  <validation-provider v-slot="{ errors }" class="mb-2" rules="required" name="Mã lớp">
                    <v-text-field :error-messages="errors" disabled id="class-code" v-model="formModel.classCode"></v-text-field>
                  </validation-provider>
                </div>
              </v-list-item-content>
            </v-list-item>
            <div class="block-native px-3">
              <div class="teacher-info-personal">
                <div class="d-flex justify-space-between align-center">
                  <div class="noti-right" v-if="classId && formModel.statusId !== LOP_NHAP">
                    <v-select
                      :items="TRANG_THAI_LOP"
                      item-text="name"
                      item-value="id"
                      v-model="formModel.statusId"
                      label="Trạng thái lớp"
                      disabled
                      attach
                      readonly
                    >
                    </v-select>
                  </div>
                  <div class="noti-right" v-if="classId && formModel.statusId === LOP_NHAP">
                    <v-select
                      :items="TRANG_THAI_LOP_NHAP"
                      item-text="name"
                      item-value="id"
                      v-model="formModel.statusId"
                      label="Trạng thái lớp"
                      disabled
                      readonly
                    >
                    </v-select>
                  </div>
                </div>
                <div class="d-flex justify-space-between align-center">
                  <div class="noti-right">
                    <validation-provider v-slot="{ errors }" class="mb-2" rules="required" name="Môn">
                      <v-select disabled :error-messages="errors" :items="SUBJECTS_SORT_CLASS" item-text="name" item-value="id"
                                label="Môn*" v-model="formModel.subjectId"></v-select>
                    </validation-provider>
                  </div>
                </div>
                <div class="d-flex justify-space-between align-center">
                  <div class="noti-right">
                    <validation-provider v-slot="{ errors }" class="mb-2" rules="required" name="Chương trình">
                      <v-autocomplete
                        disabled
                        :error-messages="errors"
                        item-text="title"
                        item-value="id"
                        :items="listCurriculums"
                        v-model="formModel.curriculumId"
                        label="Chương trình*"
                        readonly
                      >
                      </v-autocomplete>
                    </validation-provider>
                  </div>
                </div>
                <div class="d-flex justify-space-between align-center">
                  <div class="noti-right">
                    <validation-provider v-slot="{ errors }" class="mb-2" rules="required" name="Loại giáo viên">
                      <v-select
                        disabled
                        :error-messages="errors"
                        item-text="name"
                        item-value="id"
                        :items="teacherTypes"
                        v-model="formModel.teacherType"
                        label="Loại giáo viên*"
                        @change="changeOption"
                        item-disabled="disable"
                        readonly
                      >
                      </v-select>
                    </validation-provider>
                  </div>
                </div>
                <div class="d-flex justify-space-between align-center">
                  <div class="noti-right">
                    <validation-provider v-slot="{ errors }" class="mb-2" rules="required" name="Loại lớp"
                    >
                      <v-select
                        disabled
                        :error-messages="errors"
                        item-text="name"
                        item-value="id"
                        :items="formModel.subjectId === subjectIdTutorSortClass.MON_TOAN ? LOAI_LOP_TOAN : LOAI_LOP"
                        label="Loại lớp*"
                        v-model="formModel.classType"
                        @change="changeOption"
                        readonly
                      >
                      </v-select>
                    </validation-provider>
                  </div>
                </div>
                <div class="d-flex justify-space-between align-center">
                  <div class="noti-right">
                    <v-select
                      disabled
                      readonly
                      item-text="name"
                      item-value="id"
                      :items="VUNG_MIEN_GV"
                      v-model="formModel.regionId"
                      label="Vùng miền"
                    >
                    </v-select>
                  </div>
                </div>
                <div class="d-flex justify-space-between align-center">
                  <div class="noti-right">
                    <validation-provider v-slot="{ errors }" class="mb-2" rules="required" name="Trình độ"
                    >
                      <v-select
                        :error-messages="errors"
                        item-text="name"
                        item-value="id"
                        :items="levels"
                        label="Trình độ*"
                        v-model="formModel.level"
                        :menu-props="{ bottom: true, offsetY: true, maxHeight: '100' }"
                        @change="changeOption('level')"
                        readonly
                        disabled
                      >
                      </v-select>
                    </validation-provider>
                  </div>
                </div>
                <div class="d-flex justify-space-between align-center mb-12 pb-12" v-if="formModel.subjectId === subjectIdTutorSortClass.MON_TIENG_ANH">
                  <div class="noti-right" v-if="formModel.subjectId === subjectIdTutorSortClass.MON_TIENG_ANH">
                    <v-select
                      readonly
                      disabled
                      attach
                      item-text="name"
                      item-value="id"
                      :items="subLevel"
                      label="Sub level"
                      v-model="formModel.subLevel"
                      :menu-props="{ bottom: true, offsetY: true, maxHeight: '100' }"
                    >
                    </v-select>
                  </div>
                </div>
              </div>
            </div>
            <v-expansion-panels focusable></v-expansion-panels>
          </v-form>
        </validation-observer>
      </div>
      <v-divider vertical></v-divider>
      <div class="teacher-info">
        <div class="tab-teacher-sort">
          <v-tabs v-model="tab" slider-color="yellow" class="pl-7">
            <v-tabs-slider color="#FF7A00"></v-tabs-slider>
            <v-tab>THÔNG TIN LỚP</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <div class="info-class pl-7">
                <div class="mb-4">
                  <v-simple-table class="mt-5" cellspacing="0" cellpadding="0" style="table-layout: fixed">
                    <thead>
                      <tr class="table-student-head f-12" style="white-space: nowrap;">
                        <th class="f-12 px-4 head-name" style="width: 200px;">Tên con</th>
                        <th style="width: 80px;" class="text-center f-12">Số buổi</th>
                        <th class="f-12" style="width: 180px;">Note</th>
                      </tr>
                    </thead>
                    <tbody style="background: #F8F8F8" class="f-12">
                    <tr class="table-student-body">
                      <td class="pl-4 f-12">
                        <span class="student-name" >
                          {{ student.name }}
                        </span>
                        <span v-if="student.status == STATUS_HOC_THU" class="pa-1 ml-1 trial-badge">TRIAL</span>
                      </td>
                      <td class="text-center f-12">
                        {{ student.lessionPassedNumber ? student.lessionPassedNumber : '0' }} /
                        {{ student.totalLessionNumber ? student.totalLessionNumber : '0' }}</td>
                      <td class="pr-2 py-2 f-12" style="word-break: break-word">
                        {{  _.get(student, 'lastNote.note') || student.note || '--' }}
                      </td>
                    </tr>
                    </tbody>
                  </v-simple-table>
                </div>
                <!-- Type 1 -->
                <div v-if="typeSelectedClass == 1" class="info-class__schedules">
                  <div>
                    <div class="d-flex justify-space-between align-center info-class__title">
                      <h3 class="font-weight-bold">Chọn lịch học</h3>
                      <div class="d-flex align-center">
                        <div class="d-flex align-center">
                          Thời lượng
                          <v-select
                            :items="durations"
                            v-model="filterSchedule.duration"
                            style="width: 120px; margin-left: 8px; margin-right: 32px"
                            height="32"
                            dense
                            hide-details
                            outlined
                            placeholder="Chọn"
                            clearable
                          >
                          </v-select>
                        </div>
                        <v-radio-group v-model="filterSchedule.caseType" hide-details row class="radio-filter-teacher">
                          <template v-for="(type, index) in listCaseTypes">
                            <v-radio :label="type.name" :value="type.id" :key="'caseType' + index"></v-radio>
                          </template>
<!--                          <v-radio  label="Sáng"></v-radio>-->
<!--                          <v-radio label="Chiều"></v-radio>-->
<!--                          <v-radio style="order: 3" label="Tối"></v-radio>-->
<!--                          <v-radio style="order: 4" label="Tất cả"></v-radio>-->
                        </v-radio-group>
                      </div>
                    </div>
                    <v-simple-table class="table-case table-studying-pick-case mt-4">
                      <template v-slot:default>
                        <thead>
                        <tr>
                          <th
                            v-for="(caseType, key) in caseTypeText"
                            :key="key"
                            class="thead-case"
                            :style="{ fontWeight: caseType == 'Ca học' ? '700' : '' }"
                            :class="`${caseType === 'Ca học' ? 'text-left' : 'text-center'}`"
                          >
                            {{ caseType }}
                          </th>
                        </tr>
                        </thead>
                        <tbody style="background: #F8F8F8" v-if="_.size(listSchedule) > 0">
                          <tr v-for="(calendar, iCalendar) in listSchedule" :key="iCalendar">
                            <td class="" style="font-weight: 700">
                              {{calendar.times}}
                            </td>
                            <td style="position: relative" class="text-center" v-for="(day, iDay) in calendar.items" :key="iCalendar + '_' + iDay">
                              <!--                          <template v-if="day.isDisable">-->
                              <!--                          </template>-->
                              <template>
                                <input type="checkbox" :disabled="day.isDisable || (day.isRestricted && !day.originalChecked)" class="check-schedule" @change="selectSchedule()"
                                       v-model="day.isChecked">
                                <v-tooltip bottom content-class="custom-tooltip" color="blue">
                                  <template #activator="{ on: onTooltip }">
                                    <v-icon v-on="{ ...onMenu, ...onTooltip }" color="blue" class="ml-1" style="position: absolute; top: 0%; right: 0;" v-if="(day.isRestricted && !day.isChecked)">mdi-information</v-icon>
                                  </template>
                                  <span style="color: #fff;">Khung giờ này đã hết lịch trống</span>
                                </v-tooltip>
                              </template>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td :colspan="_.size(caseTypeText)">Không có ca học phù hợp</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <div class="d-flex justify-center">
                      <v-btn
                        color="#FF6609"
                        width="106"
                        height="32"
                        class="mt-4"
                        style="text-transform: initial; color: white"
                        @click="search = true; findTeachers()"
                      >
                        Tìm giáo viên
                      </v-btn>
                    </div>
                  </div>
                  <div class="info-class__teacher mt-4" v-show="typeSelectedClass == 1">
                    <div class="d-flex justify-space-between align-center">
                      <h4>Chọn giáo viên</h4>
                      <div>
                        <v-text-field
                          outlined
                          placeholder="Nhập mã GV để tìm kiếm..."
                          v-model="keySearchTeacher"
                          dense
                          hide-details
                          style="width: 250px"
                          @keyup.enter="findTeachers(null)"
                        ></v-text-field>
                      </div>
                    </div>
                    <v-simple-table ref="table2" class="table-studying-pick mt-4" :height="computedTeacherTableHeight">
                      <template v-slot:default>
                        <thead>
                          <tr style="background: #FFF5D0">
                            <th class="thead-case" style="min-width: 16px; max-width: 16px"></th>
                            <th class="text-left thead-case" style="min-width:130px; max-width: 130px">Tên giáo viên</th>
                            <th class="text-left thead-case mx-2" style="min-width:80px; max-width: 80px">Thâm niên</th>
                            <th class="text-left thead-case mx-2" style="min-width:80px; max-width: 80px">Điểm QC</th>
                            <th class="text-left thead-case mx-2" style="min-width:80px; max-width: 80px">Vùng miền</th>
                          </tr>
                        </thead>
                        <template v-if="_.size(teachers) > 0">
                          <tbody>
                          <tr style="cursor: pointer;"
                              v-for="(teacher, iTeacher) in teachers"
                              :key="iTeacher"
                              :class="formModel.teacherId == teacher.id ? 'active-teacher-sort-class' : ''"
                              @click="selectTeacher(teacher)"
                          >
                            <td>
                              <v-icon color="green" v-if="formModel.teacherId == teacher.id">mdi-check-bold</v-icon>
                            </td>
                            <td class="">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <div v-bind="attrs" v-on="on" class="name-teacher-table d-flex align-center">
                                    <template v-if="teacher.nickname">{{teacher.nickname}}:</template><template v-if="!teacher.nickname && teacher.code">{{teacher.code}}:</template>
                                    {{teacher.name}}
                                    <img style="margin-left: 4px" src="../assets/female-icon.svg" alt="" v-if="teacher.gender === GENDER.FEMALE">
                                    <img style="margin-left: 4px" src="../assets/male-icon.svg" alt="" v-if="teacher.gender === GENDER.MALE">
                                  </div>
                                </template>
                                <span>
                                  {{teacher.name}}
                                </span>
                              </v-tooltip>

                            </td>
                            <td class="text-left">
                              <div v-if="teacher.onboardTime">{{moment(new Date()).diff(moment(teacher.onboardTime, 'DD/MM/YYYY'), 'month')}} tháng</div>
                              <div v-else>-</div>
                            </td>
                            <td class="text-left">
                              <div v-if="teacher.rankQc">{{teacher.rankQc}}</div>
                              <div v-else>-</div>
                            </td>
                            <td class="text-left">
                              <div v-if="teacher.regionId && REGION.find((e) => e.id === teacher.regionId)" class="regionClass">
                                <div class="region-box" :style="{ color: REGION.find((e) => e.id === teacher.regionId).color}">
                                  {{REGION.find((e) => e.id === teacher.regionId).name}}
                                </div>
                              </div>
                              <div v-else>
                                -
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </template>
                        <template v-else>
                          <tbody>
                            <tr>
                              <td colspan="7">
                                <span class="pl-3 text-no-wrap" style="color: red">Không có giáo viên phù hợp.</span>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </template>
                    </v-simple-table>
                    <v-divider class="mt-5"></v-divider>
                  </div>
                  <div class="info-class__action mt-2 d-flex" v-if="classId">
                    <v-btn v-if="formModel.statusId == LOP_NHAP"
                           :disabled="!(checkAuthorization('class-manage_update') && ($route.query.typeCurriculum == 'manageClassOnline' || $route.query.typeCurriculum == 'studentOnline'))
                                && !(checkAuthorization('class-manage-ieltsy_update') && ($route.query.typeCurriculum == 'manageClassIeltsy' || $route.query.typeCurriculum == 'studentIeltsy'))
                                && !(checkAuthorization('sort-class_update') && $route.query.typeCurriculum == 'online')
                                && !(checkAuthorization('sort-class-ieltsy_update') && $route.query.typeCurriculum == 'ieltsy')"
                           @click="deleteDraftClass" rounded width="85" height="11" class="mr-3" color="#EFF0F7" style="text-transform: initial; color: #333">
                      Xóa lớp nháp
                    </v-btn>
                    <v-btn v-else @click="closeModalDetailClass" rounded width="30" height="11" class="mr-3" color="#EFF0F7" style="text-transform: initial; color: #333">
                      Hủy
                    </v-btn>
                    <v-btn @click="submit()"
                           :disabled="!(checkAuthorization('class-manage_update') && ($route.query.typeCurriculum == 'manageClassOnline' || $route.query.typeCurriculum == 'studentOnline'))
                                && !(checkAuthorization('class-manage-ieltsy_update') && ($route.query.typeCurriculum == 'manageClassIeltsy' || $route.query.typeCurriculum == 'studentIeltsy'))
                                && !(checkAuthorization('sort-class_update') && $route.query.typeCurriculum == 'online')
                                && !(checkAuthorization('sort-class-ieltsy_update') && $route.query.typeCurriculum == 'ieltsy')"
                           rounded width="30" height="11" class="mr-3" color="#FF6609" style="text-transform: initial">
                      Lưu
                    </v-btn>
                    <v-btn v-if="formModel.statusId == LOP_NHAP"
                           :disabled="!(checkAuthorization('class-manage_update') && ($route.query.typeCurriculum == 'manageClassOnline' || $route.query.typeCurriculum == 'studentOnline'))
                                && !(checkAuthorization('class-manage-ieltsy_update') && ($route.query.typeCurriculum == 'manageClassIeltsy' || $route.query.typeCurriculum == 'studentIeltsy'))
                                && !(checkAuthorization('sort-class_update') && $route.query.typeCurriculum == 'online')
                                && !(checkAuthorization('sort-class-ieltsy_update') && $route.query.typeCurriculum == 'ieltsy')"
                           @click="submit('lop_thuong')" rounded width="30" height="11" class="mr-3" color="#FF6609" style="text-transform: initial">
                      Xác nhận
                    </v-btn>
                  </div>
                </div>
                <div class="info-class__info mt-6">
                  <h3 class="font-weight-bold">Thông tin lớp</h3>
                  <div>
                    <validation-observer ref="validatorStudentInfo">
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <validation-provider name="Ngày khai giảng" rules="required" v-slot="{errors}" v-model="formModel.startDate">
                            <v-text-field
                              style="width: 200px"
                              clearable
                              v-model="computedStartDateFormatted"
                              label="Ngày khai giảng"
                              placeholder="Chọn ngày"
                              persistent-placeholder
                              readonly
                              :error-messages="errors"
                              v-bind="attrs"
                              v-on="on"
                              @click:clear="formModel.startDate = ''"
                            >
                              <template v-slot:label>
                                Ngày khai giảng <span style="color: red">*</span>
                              </template>
                            </v-text-field>
                          </validation-provider>
                        </template>
                        <v-date-picker
                          v-model="formModel.startDate"
                          class="appointment-date-picker"
                          :min="minStartDate"
                          :allowed-dates="allowedStartDate"
                          no-title
                          locale="vi-en"
                          format
                          @input="menu = false"
                        >
                        </v-date-picker>
                      </v-menu>

                      <validation-provider v-slot="{errors}" rules="required" name="Link nhóm zalo">
                        <v-text-field
                          class="mt-4"
                          v-model="formModel.zaloLink"
                          persistent-placeholder
                          :error-messages="errors"
                          label="Link nhóm Zalo"
                          placeholder="Nhập link"
                          style="width: 100%"
                          clearable
                        >
                          <template v-slot:label>
                            Link nhóm zalo <span style="color: red">*</span>
                          </template>
                        </v-text-field>
                      </validation-provider>
                    </validation-observer>
                    <div class="warning-box mt-4">
                      Lưu ý: Nếu
                      <span style="font-weight: bold; margin: 0 3px 0">
                      chưa tìm được GV
                      </span>phù hợp hoặc
                      <span style="font-weight: bold; margin: 0 3px 0">PH hẹn ngày xếp lớp sau </span>
                      thì cần
                      <span style="font-weight: bold; margin: 0 3px 0">
                        chuyển ngay
                      </span>
                      sang cho bộ phận Vận hành xử lý.
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-space-between align-center mt-4 mb-2">
                  <div>
                    <v-btn color="#ED185A" style="color: white; margin-right: 8px" small @click="handleCreateClass">Tạo lớp mới</v-btn>
                    <v-btn color="#AEAEB2" style="color: white" small @click="closeModalDetailClass">Thoát</v-btn>
                  </div>
                  <div>
                    <v-btn color="#0069C8" style="color: white" small @click="openChangeOperatorPopup">Chuyển vận hành</v-btn>
                  </div>
                </div>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
    </div>
    <v-dialog v-model="isShowChangeOperatorPopup" width="650">
      <ChangeOperatorPopup
        :studentCareInfo="studentCareInfo"
        @finish-change-operator="finishChangeOperator"
        :studentProductId="studentProductId"
        @close="isShowChangeOperatorPopup = false"></ChangeOperatorPopup>
    </v-dialog>
    <ConfirmCreateClassPopup
      :isShow="isShowCreateClass"
      :student="student"
      :teacher="selectedTeacher"
      :studentProductId="studentProductId"
      :data="formModel"
      :student-care-info="studentCareInfo"
      @finish-create-class="finishCreateClass"
      @close="isShowCreateClass = false"/>
  </v-card>
</template>

<script>
import ConfirmCreateClassPopup from '@/modules/student_care/components/ConfirmCreateClassPopup.vue';
import ChangeOperatorPopup from '@/modules/student_care/components/ChangeOperatorPopup.vue';
import moment from 'moment';
import {
  STATUS_HOC_THU,
  subjectIdTutorSortClass,
  LOP_NHAP,
  TRANG_THAI_LOP,
  TRANG_THAI_LOP_NHAP,
  SUBJECTS_SORT_CLASS,
  subjectIdTACrm,
  LOAI_GIAOVIENT_VN,
  LOAI_LOP_TOAN,
  LOAI_LOP,
  VUNG_MIEN_GV,
  levelEnglish,
  LevelLiterature,
  LevelMath,
  LOP_GV,
  hourTypeConfig,
  GENDER,
  REGION,
  subLevel,
} from '@/modules/student_care/constant/constant';
import StudentCareServices from '@/services/StudentCareServices';
import { LOAI_GIAOVIEN } from '@/helpers/constant';
import TutorSortClassRepository from '@/services/TutorSortClassRepository';
import _ from 'lodash';

export default {
  name: 'ModalDetailClass',
  components: { ChangeOperatorPopup, ConfirmCreateClassPopup },
  props: {
    studentCareInfo: {
      type: Object,
      required: true,
    },
    studentProductId: {
      type: Number,
      required: true,
    },
    closeModalDetailClass: {
      require: true,
      type: Function,
    },
    classId: {
      type: Number,
    },
  },
  data() {
    return {
      keySearchTeacher: '',
      menu: false,
      selectedTeacher: {},
      isShowChangeOperatorPopup: false,
      moment,
      subLevel,
      REGION,
      GENDER,
      STATUS_HOC_THU,
      hourTypeConfig,
      LOP_GV,
      LOAI_LOP,
      LOAI_LOP_TOAN,
      VUNG_MIEN_GV,
      subjectIdTutorSortClass,
      SUBJECTS_SORT_CLASS,
      TRANG_THAI_LOP,
      TRANG_THAI_LOP_NHAP,
      LOP_NHAP,
      subjectIdTACrm,
      levelEnglish,
      LevelMath,
      LevelLiterature,
      student: {},
      caseTypeText: ['Ca học', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7', 'Chủ nhật'],
      hourType: 2,
      listScheduleClone: [],
      listSchedule: [],
      typeSelectedClass: 1,
      listStudentWaitting: [],
      students: [],
      teachers: [],
      tab: 0,
      keyRender: 0,
      listCurriculums: [],
      durations: [],
      listCaseTypes: [],
      filterSchedule: {
        duration: null,
        caseType: null,
      },
      originFormModel: {
        classCode: null,
        className: null,
        classType: null,
        gradeId: null,
        level: null,
        regionId: null,
        subjectId: null,
        teacherType: null,
        startDate: '',
        endDate: '',
        teacherId: null,
        classId: null,
        action: '',
        statusId: null,
        subLevel: null,
        curriculumId: null,
        schoolId: null,
        schoolClassroomId: null,
        arrangeClassType: null,
        bookIds: [],
        cases: [],
        classAssignmentAppointmentDate: '',
      },
      formModel: { ...this.originFormModel },
      timoutFilterTeacher: null,
      LOAI_GIAOVIENT_VN,
      LOAI_GIAOVIEN: [
        ...LOAI_GIAOVIEN,
        {
          id: 5,
          name: 'Mix',
        },
      ],
      isShowCreateClass: false,
    };
  },
  async created() {
    this.formModel = _.cloneDeep(this.originFormModel);
    this.getCurriculum(_.get(this.formModel, 'subjectId', null));
    await this.getStudentInfo();
    await this.getListSchedules();
  },
  methods: {
    allowedStartDate(val) {
      const dayAllowed = [];
      const filterSchedules = this.filterSchedules();
      filterSchedules.forEach((e) => {
        if (!dayAllowed.includes(e.dayOfWeek)) {
          dayAllowed.push(e.dayOfWeek);
        }
      });
      return dayAllowed.includes(moment(val).day());
    },
    // filterTeacher() {
    //   this.findTeachers();
    // },
    finishChangeOperator() {
      this.isShowChangeOperatorPopup = false;
      this.closeModalDetailClass();
      Bus.$emit('reload-student-detail-info');
    },
    finishCreateClass() {
      this.isShowCreateClass = false;
      this.closeModalDetailClass();
      Bus.$emit('reload-student-detail-info');
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    async handleCreateClass() {
      const cases = this.filterSchedules();
      // eslint-disable-next-line no-unused-expressions
      if (_.size(cases) === 0 && this.typeSelectedClass === 1) {
        this.$swal({
          icon: 'warning',
          title: 'Thông báo !',
          text: 'Vui lòng chọn lịch học.',
        });
        return;
      }
      if (!this.formModel.teacherId) {
        this.$swal({
          icon: 'warning',
          title: 'Thông báo !',
          text: 'Vui lòng chọn giáo viên.',
        });
        return;
      }
      const isValidInfo = await this.$refs.validatorStudentInfo.validate();
      if (!isValidInfo) {
        return;
      }
      this.isShowCreateClass = true;
    },
    handleTableScroll(e) {
      if ((e.target.scrollHeight - e.target.scrollTop) === e.target.clientHeight) {
        this.findTeachers(null, this.teachers[this.teachers.length - 1].id);
      }
    },
    openChangeOperatorPopup() {
      this.isShowChangeOperatorPopup = true;
    },
    selectTeacher(teacher) {
      this.selectedTeacher = teacher;
      this.formModel = {
        ...this.formModel,
        teacherId: teacher.id,
      };
    },
    checkExitSchedule() {
      const selectedSchedules = [];
      let flag = false;
      const teacher = _.find(this.teachers, (item) => item.id === this.formModel.teacherId);
      if (teacher) {
        flag = true;
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.listSchedule.length; i++) {
          const current = this.listSchedule[i];
          // eslint-disable-next-line no-plusplus
          for (let j = 0; j < current.items.length; j++) {
            const currentSchedule = current.items[j];
            if (currentSchedule.isChecked) {
              selectedSchedules.push({
                caseId: current.id,
                dayOfWeek: currentSchedule.dayOfWeek,
              });
            }
          }
        }
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < selectedSchedules.length; i++) {
          const current = selectedSchedules[i];
          let exitSchedule = false;
          // eslint-disable-next-line no-plusplus
          for (let j = 0; j < teacher.emptySchedules.length; j++) {
            const teacherSchedule = teacher.emptySchedules[j];
            // eslint-disable-next-line no-plusplus
            for (let k = 0; k < teacherSchedule.schedules.length; k++) {
              const schedule = teacherSchedule.schedules[k];
              if (schedule.caseId === current.caseId && teacherSchedule.dayOfWeek === current.dayOfWeek) {
                exitSchedule = true; break;
              }
            }
            if (exitSchedule) { break; }
          }
          if (!exitSchedule) {
            flag = false;
            break;
          }
        }
      }
      return flag;
    },
    selectSchedule() {
      const flag = this.checkExitSchedule();
      if (!flag) {
        this.teachers = [];
        this.formModel = {
          ...this.formModel,
          teacherId: null,
        };
      }
    },
    filterSchedules() {
      const listSchedules = [];
      const listScheduleClone = _.cloneDeep(this.listSchedule);
      if (this.typeSelectedClass === 1) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < listScheduleClone.length; i++) {
          const item = listScheduleClone[i];
          // eslint-disable-next-line no-plusplus
          for (let j = 0; j < item.items.length; ++j) {
            const schedules = item.items[j];
            if (schedules.isChecked) {
              const output = {
                caseId: item.id,
                dayOfWeek: schedules.dayOfWeek,
                nameDayOfWeek: schedules.nameDayOfWeek,
                fromTime: item?.times?.split('-')[0]?.trim(),
                toTime: item?.times?.split('-')[1]?.trim(),
              };
              listSchedules.push(output);
            }
          }
        }
      } else {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.listScheduleAndTeacherOrigin.length; i++) {
          const item = this.listScheduleAndTeacherOrigin[i];
          if (item.mainTeacher.id && item.dayOfWeek && item.time && !item.hidden) {
            const output = {
              caseId: item.time.id,
              dayOfWeek: item.dayOfWeek.id,
              nameDayOfWeek: item.nameDayOfWeek,
              fromTime: item.time?.times.split('-')[0]?.trim(),
              toTime: item.time?.times.split('-')[1]?.trim(),
              teacherId: item.mainTeacher.id,
              subTeacherId: item.subTeacher.id,
              schoolClassId: this.typeManagedClass === 'manageClassIeltsy' ? item.valueClassRoomsSelectType2.id || this.formModel.schoolClassroomId : null,
            };
            listSchedules.push(output);
          }
        }
      }
      return listSchedules;
    },
    getErrorMessage(error) {
      let { message } = error;
      if (error.errors && error.errors.errors && _.isArray(error.errors.errors)) {
        message = error.errors.errors.join(', ');
      } else if (error.errors && error.errors.message) {
        message = error.errors.message;
      }
      return message;
    },
    async findTeachers(caseType2 = null, lastTeacherId) {
      this.suggestValue = '';
      try {
        let cases = this.filterSchedules();
        this.formModel.cases = cases;
        // eslint-disable-next-line no-unused-expressions
        caseType2 ? cases = caseType2 : null;
        if (_.size(cases) === 0 && this.typeSelectedClass === 1) {
          this.$swal({
            icon: 'warning',
            title: 'Thông báo !',
            text: 'Vui lòng chọn lịch học.',
          });
          return;
        }
        const params = {
          cases,
          subjectId: this.formModel.subjectId,
          teacherType: this.formModel.teacherType,
          level: this.formModel.level,
          gradeId: this.formModel?.gradeId,
          classType: this.formModel.classType,
          search: true,
          curriculumId: this.formModel?.curriculumId,
          nameCode: this.keySearchTeacher ? this.keySearchTeacher : undefined,
        };
        if (lastTeacherId) {
          params.lastTeacherId = lastTeacherId;
        }
        this.payloadTeacher = params;
        if (this.$route.query.typeCurriculum === 'ieltsy' || this.$route.query.typeCurriculum === 'manageClassIeltsy' || this.$route.query.typeCurriculum === 'studentIeltsy') {
          params.typeCurriculum = 'ieltsy';
          params.schoolId = this.formModel?.schoolId;
        } else {
          params.typeCurriculum = 'online';
        }
        if (this.formModel.action) {
          params.action = this.formModel.action;
        }
        if (this.classId) {
          params.classId = this.classId;
        }
        // eslint-disable-next-line no-plusplus
        this.keyRender++;
        const responses = await TutorSortClassRepository.getListTeachers(params);
        const { data } = responses;
        if (_.size(data) === 0 && !lastTeacherId && _.size(this.teachers) === 0) {
          this.$swal({
            icon: 'warning',
            title: 'Thông báo !',
            text: this.getErrorMessage(responses) || 'Không tìm thấy giáo viên phù hợp.',
          });
          return;
        }
        if (caseType2) {
          this.teachersType2 = data;
          this.teachersType2Clone = _.cloneDeep(this.teachersType2);
        } else {
          if (lastTeacherId) {
            this.teachers = this.teachers.concat(data);
          } else {
            this.teachers = data;
          }
          this.teachersClone = _.cloneDeep(this.teachers);
        }
        const table = this.$refs.table2.$el.children[0];
        table.addEventListener('scroll', this.handleTableScroll);
      } catch (e) {
        this.$swal({
          type: 'error',
          title: 'Thông báo',
          text: _.get(e, 'message', 'Lỗi! Vui lòng thử lại'),
        });
      }
    },

    async getStudentInfo() {
      const res = await TutorSortClassRepository.getStudentInfo(this.studentProductId);
      if (res.success) {
        this.student = _.cloneDeep(_.get(res, 'data[0]', {}));
        this.formModel.curriculumId = _.get(res, 'data[0].curriculum.id');
        this.formModel.subjectId = _.get(res, 'data[0].subject.id');
        this.formModel.teacherType = _.get(res, 'data[0].teacherType.id');
        this.formModel.classType = _.get(res, 'data[0].classType.id');
        this.formModel.regionId = _.get(res, 'data[0].region.id');
        this.formModel.level = _.get(res, 'data[0].level.id');
        this.formModel.subLevel = _.get(res, 'data[0].subLevel.id');
      }
    },
    async getListSchedules() {
      const params = {
        subjectId: +this.formModel.subjectId,
        hourType: hourTypeConfig[this.hourType],
        classType: this.formModel.classType,
      };
      if (this.$route.query.typeCurriculum === 'ieltsy') {
        params.typeCurriculum = 'ieltsy';
      } else {
        params.typeCurriculum = 'online';
      }
      if (this.classId) {
        params.classId = this.classId;
      }
      const loader = this.$loading.show();
      const responses = await TutorSortClassRepository.getListSchedules(params);
      this.listTime = _.get(responses, 'data.schedules', []);
      this.durations = _.get(responses, 'data.listDurations', []);
      this.listCaseTypes = _.get(responses, 'data.listCaseTypes', []);
      this.listTime.map((item) => ({
        id: item.times,
        name: item.times,
        goldenHour: item.goldenHour,
      }));
      loader.hide();
      this.listSchedule = _.get(responses, 'data.schedules', []);
      this.listScheduleClone = _.cloneDeep(this.listSchedule);
    },
    async getCurriculum(subjectIdErp) {
      let params = {
        obj: 'program',
        attrs: ['id', 'title'],
        'filters[$eq__subject_id]': subjectIdErp === subjectIdTutorSortClass.MON_TIENG_ANH ? this.subjectIdTACrm : subjectIdErp,
        'filters[$eq__status]': 1,
        'filters[$eq__type_curriculum]': 'online',
      };
      if (['studentIeltsy', 'manageClassIeltsy', 'ieltsy'].includes(this.$route.query?.typeCurriculum)) {
        params = {
          ...params,
          'filters[$eq__type_curriculum]': 'ieltsy',
        };
      }
      const res = await StudentCareServices.fgGetListCrm(params);
      this.listCurriculums = _.get(res, 'data', []);
    },
    changeOption(atr) {
      if (atr === 'subject') {
        this.formModel.gradeId = null;
        this.formModel.teacherType = null;
        this.formModel.classType = null;
        this.formModel.level = null;
        this.formModel.curriculumId = null;
        this.formModel.schoolId = null;
        this.listSchedule = [];
        this.getCurriculum(this.formModel.subjectId);
      }
      if (!this.classId && atr && atr === 'level') {
        this.students = [];
      }
      // if (!this.classId) {
      const checkInfo = this.checkInfoClass();
      if (checkInfo) {
        this.getListSchedules();
      }
      this.teachers = [];
      this.formModel.teacherId = null;
      // }
    },
  },
  computed: {
    computedTeacherTableHeight() {
      switch (_.size(this.teachers)) {
        case 0:
        case 1:
          return 100;
        case 2:
          return 150;
        case 3:
          return 200;
        case 4:
          return 250;
        default:
          return 300;
      }
    },
    minStartDate() {
      return moment(new Date()).add(2, 'day').format('YYYY-MM-DD');
    },
    computedStartDateFormatted() {
      return this.formatDate(this.formModel.startDate);
    },
    levels() {
      if (this.formModel.subjectId === subjectIdTutorSortClass.MON_TIENG_ANH) return levelEnglish;
      if (this.formModel.subjectId === subjectIdTutorSortClass.MON_TOAN) return LevelMath;
      if (this.formModel.subjectId === subjectIdTutorSortClass.MON_NGU_VAN) return LevelLiterature;
      return [];
    },
    teacherTypes() {
      if (this.formModel.subjectId === subjectIdTutorSortClass.MON_TIENG_ANH) return this.LOAI_GIAOVIEN;
      return LOAI_GIAOVIENT_VN;
    },
    imageSubject() {
      if (this.formModel.subjectId === subjectIdTutorSortClass.MON_TIENG_ANH) return 'Tiếng Anh';
      if (this.formModel.subjectId === subjectIdTutorSortClass.MON_TOAN) return 'Toán';
      if (this.formModel.subjectId === subjectIdTutorSortClass.MON_NGU_VAN) return 'Ngữ Văn';
      return 'Toán';
    },
  },
  watch: {
    filterSchedule: {
      deep: true,
      handler(val) {
        this.listSchedule = _.cloneDeep(this.listScheduleClone);
        if (val.duration) {
          this.listSchedule = this.listSchedule.filter((e) => e.duration === val.duration);
        }
        if (val.caseType) {
          this.listSchedule = this.listSchedule.filter((e) => e.caseType === val.caseType);
        }
        // this.listSchedule = this.listSchedule.filter((e) => e.duration === val.duration && e.caseType === val.caseType);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.noti-right {
  width: 100%;
}
.closeDetailClass {
  position: absolute;
  right: 15px;
  top: 9px;
}
.show-info-teacher {
  .class-sort-pick-date .vue-daterange-picker .daterangepicker {
    min-width: 300px !important;
    top: -229px !important;
    left: 219px !important;
  }

  .daterangepicker:after,
  .daterangepicker:before {
    position: absolute;
    display: inline-block;
    border-bottom-color: rgba(0, 0, 0, 0.2);
    content: none !important;
  }

  .daterangepicker.show-calendar .ranges {
    margin-top: 8px;
    display: none;
  }

  .image-subject {
    width: 95px;
    height: 78px;
    margin-right: 12px;
    text-align: left;
    padding: 10px;
    display: inline-grid;
    background: #cf7878;

    b {
      color: white;
      font-size: 15px;
    }

    span.image-classtype {
      color: white;
      position: absolute;
      top: 46px;
      padding: 1px 2px;
      border-radius: 4px;
    }
  }
  .not-last {
    text-decoration: line-through;
  }
}

.v-card.show-info-teacher {
  font-family: "Quicksand", sans-serif;

  .content-teacher {
    display: flex;

    .nav-infoTeacher {
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 14px;
      letter-spacing: 0px;
      text-align: left;
      width: 320px;

      .update-name {
        width: 300px;
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 20px;

        span {
          width: calc(100% - 50px);
          text-align: right;
        }
      }

      .name-teacher {
        border-bottom: 1px solid #d1d1d1;
        outline: none;
        padding: 0px 0px 5px 0px;
      }

      .phone {
        a {
          color: #6e7191;
          text-decoration: none;
          font-size: 13px;
        }
      }

      .submitInfoClass {
        text-align: center;
        width: 100%;

        button {
          box-shadow: 0px 0px 4px 0px #4d4d4d1a;
          color: #fe5722;
          border: 1px solid #fe5722;
          height: 36px;
          border-radius: 24px;
          background: #ffffff;
          text-align: center;
          margin-right: 5px!important;

          &:hover {
            color: #ffffff;
            background: #fe5722;
          }
        }
      }
    }

    .teacher-info {
      width: calc(100% - 350px);
      padding: 16px 0;

      .activities-card {
        border-radius: 8px;
        background: #e1f2fc;
        border: 0.5px solid #08a0f7;
        box-shadow: 0px 2px 1px 0px #4048520d;
        text-align: center;
        position: relative;
        height: 77px;

        .activities-time {
          display: flex;
          align-items: baseline;
          justify-content: center;

          b {
            color: #08a0f7;
            font-size: 36px;
          }

          p {
            color: #08a0f7;
            font-size: 14px;
            font-weight: 700;
          }
        }

        span {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 9px;
          font-size: 12px;
        }
      }
    }
  }
}
.teacher-info-personal {
  padding: 0 5px 0 11px;
}
.tab-teacher-sort .v-tabs-slider {
  display: block !important;
}
.tab-teacher-sort {
  .v-tab--active {
    color: #ED185A !important;
  }
}
.tab-teacher-sort .v-slide-group__content {
  justify-content: space-around !important;
  border-bottom: 1px solid #f7f7fc !important;
}
tr.active-teacher-sort-class {
  background: #e7faf4;
}
table {
  width: 100%;

  .table-student-head {
    background: #F1F7FF;
    height: 37px;
    text-align: left;
    tbody {
      background: #F8F8F8 !important;
    }
    th {
      font-weight: bold;
      color: black !important;
      min-width: 100px;
      &.head-name {
      }
    }
  }

  .table-student-body {
    height: 63px;
    text-align: left;

    .student-name {
      display: inline-grid;
      color: #2F80ED;
      font-weight: 500;
      font-size: 16px;
    }
  }
  .table-student-body {
    height: 63px;
    text-align: left;

    .student-name {
      display: inline-grid;
      color: #2F80ED;
      font-weight: 500;
      font-size: 16px;
    }
  }
}
.table-studying-pick {
  max-height: 500px !important;
  overflow-y: auto !important;
  table {
    tr {
      td {
        padding: 0 8px !important;
      }
    }
    thead {
      tr {
        th {
          color: black !important;
        }
      }
    }
  }
  .v-data-table__wrapper {
    height: unset!important;
    overflow: unset!important;
  }
}
.thead-case {
  background: #EFF0F7 !important;
  border-radius: 4.76405px 0px 0px 0px;
  color: #6E7191;
  font-weight: 500;
  font-size: 12px;
  position: sticky;
  top: 0;
  z-index: 11;
  padding: 0 8px !important;
}
.table-select-teacher-type-2 {
  height: 200px !important;
  overflow-y: auto !important;
  .v-data-table__wrapper {
    height: unset!important;
    overflow: unset!important;
  }
}
.table-case td {
  border: 1px solid #EFF0F6;
}
.check-schedule {
  transform: scale(1.5);
}
</style>
<style lang="scss">
.table-case .v-data-table__wrapper {
  max-height: 350px !important;
  overflow-y: auto !important;
}
.table-case {
  table {
    thead {
      tr {
        th {
          color: black !important;
        }
      }
    }
  }
}
.warning-box {
  background-color: #FFF0E7;
  border: 1px solid #FF2D55;
  color: #FF2D55;
  border-radius: 6px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  font-size: 13px;
}
@media screen and (max-width: 1366px) {
  .warning-box {
    font-size: 12px;
  }
}
.region-box {
  border: 1px solid #0000004D;
  border-radius: 4px;
  font-weight: bold;
  width: fit-content;
  height: fit-content;
  padding: 0px 5px;
}
.custom-tooltip {
  background-color: #E6F7FF !important; /* Màu nền tooltip */
  color: white !important; /* Màu chữ trắng */
  font-size: 12px !important;
  color: #1D2641!important;
}
</style>
